module.exports = __webpack_public_path__ + "static/media/appstore-api-step-1.9e8d2cd6.png";